import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  FormatDateToWord,
  VendorSelect,
  TermsSelect,
  ItemSelect,
  PurchaseInvoiceOptionalVendorSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';

export default function PurchaseRegister() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [terms, setTerms] = useState("");
  const [invoice, setInvoice] = useState(null);

  const [vendor, setVendor] = useState(null);
  const [showVendorSelect, setShowVendorSelect] = useState(false);

  const openVendorSelect = () => {
    setShowVendorSelect(true)
  }
  const closeVendorSelect = () => {
    setShowVendorSelect(false)
  }

  const [item, setItem] = useState(null);
  const [showItemSelect, setShowItemSelect] = useState(false);

  const openItemSelect = () => {
    setShowItemSelect(true)
  }
  const closeItemSelect = () => {
    setShowItemSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      vendorId: vendor ? vendor?.vendorId : null,
      itemCode: item ? item.itemCode : null,
      terms: terms ? terms : null,
      documentId: invoice ? invoice?.id : null,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/purchase-register`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo, vendor, item, terms, invoice]);

  // PDF
  const generatePurchaseRegisterByVendorDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byVendorDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_REGISTER_BY_VENDOR_DETAILED.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = String(text).split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = String(text);
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(vendor?.vendorName1?.toString() ?? "ALL VENDORS", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 60;
      const colWidthDesc = 85; // Adjusted based on your coordinates
      const lineHeight = 10;

      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const vendorGroup of _data) {
        // --- VENDOR HEADER ---
        if (yPosition < 100) {
          currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
          drawHeader(currentPage);
          yPosition = 446;
        }

        currentPage.drawText(`${vendorGroup.vendorName ?? "Unknown Vendor"}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 12;
        currentPage.drawText(`PURCHASE/RECEIVING`, { x: 35, y: yPosition, size: 7, font: calibriFont });
        yPosition -= 15;

        let vendorVatable = 0;
        let vendorVat = 0;
        let vendorTotal = 0;

        for (const record of vendorGroup.invoices) {
          for (const itemRow of record.items) {
            const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
            const rowHeight = Math.max(15, descLines.length * lineHeight);

            // --- PAGE BREAK CHECK ---
            if (yPosition - rowHeight < bottomThreshold) {
              currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
              drawHeader(currentPage);
              yPosition = 446;
            }

            // Draw Basic Row Info
            currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${record?.id ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

            const truncatedSalesman = truncateText(record?.salesman ?? "", 50, calibriFont, 8);
            currentPage.drawText(truncatedSalesman, { x: 160, y: yPosition, size: 8, font: calibriFont });

            // Draw Wrapped Description
            for (let i = 0; i < descLines.length; i++) {
              currentPage.drawText(descLines[i], {
                x: 128,
                y: yPosition - (i * lineHeight),
                size: 8,
                font: calibriFont,
              });
            }

            // Draw Numerics
            const qtyVal = parseFloat(itemRow.quantity) || 0;
            currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 272, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 304, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 336, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 391, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 428, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 485, y: yPosition, size: 8, font: calibriFont });
            
            // Note: your data uses vaTableSales (lowercase 'a')
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 544, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 606, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 664, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 720, y: yPosition, size: 8, font: calibriFont });

            vendorVatable += itemRow.vaTableSales || 0;
            vendorVat += itemRow.vat || 0;
            vendorTotal += itemRow.totalAmount || 0;

            yPosition -= (rowHeight + 5);
          }
        }

        // --- VENDOR SUB-TOTAL ---
        if (yPosition < 80) {
            currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
            drawHeader(currentPage);
            yPosition = 446;
        }
        currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });
        currentPage.drawText(`Supplier Sub-Total:`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Purchases: ${FormatValueToDecimal(vendorTotal)}`, { x: 128, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Purchase Return: ${FormatValueToDecimal(0)}`, { x: 272, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`Net:`, { x: 485, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 606, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVat)}`, { x: 664, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorTotal)}`, { x: 720, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 20;

        grandVatable += vendorVatable;
        grandVatAmount += vendorVat;
        grandAmount += vendorTotal;
      }

      // --- GRAND TOTAL ---
      if (yPosition < 100) {
        currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
        drawHeader(currentPage);
        yPosition = 446;
      }

      yPosition -= 10;
      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`GRAND TOTAL:`, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`Purchases: ${FormatValueToDecimal(grandAmount)}`, { x: 128, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`Purchase Return: ${FormatValueToDecimal(0)}`, { x: 272, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`Net:`, { x: 485, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 606, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 664, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 720, y: yPosition, size: 9, font: calibriBold });

      // --- PAGE NUMBERS ---
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${allPages.length}`, {
          x: 680, 
          y: 580,
          size: 9,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PURCHASE_REGISTER_BY_VENDOR_DETAILED.pdf`;
      link.click();

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF: " + error.message);
    }
    setLoading(false);
  };

  const generatePurchaseRegisterByDateDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_REGISTER_BY_DATE_DETAILED.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = String(text).split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(`${invoice?.id?.toString() ?? ""}`, { x: 72, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 60;
      const colWidthDesc = 85; // Adjusted based on your coordinates
      const lineHeight = 10;

      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let vendorVatable = 0;
        let vendorVat = 0;
        let vendorTotal = 0;

        for (const itemRow of record.items) {
          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          const rowHeight = Math.max(15, descLines.length * lineHeight);

          // --- PAGE BREAK CHECK ---
          if (yPosition - rowHeight < bottomThreshold) {
            currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
            drawHeader(currentPage);
            yPosition = 456;
          }

          // Draw Basic Row Info
          currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record?.id ?? ""}`, { x: 85, y: yPosition, size: 8, font: calibriFont });

          currentPage.drawText(record.vendorName1, { x: 183, y: yPosition, size: 8, font: calibriFont });

          // Draw Wrapped Description
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 35,
              y: (yPosition - 10) - (i * lineHeight),
              size: 8,
              font: calibriFont,
            });
          }

          // Draw Numerics
          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 184, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 223, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 270, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 363, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 430, y: yPosition - 10, size: 8, font: calibriFont });
          
          // Note: your data uses vaTableSales (lowercase 'a')
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 493, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 566, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 634, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 700, y: yPosition - 10, size: 8, font: calibriFont });

          vendorVatable += itemRow.vaTableSales || 0;
          vendorVat += itemRow.vat || 0;
          vendorTotal += itemRow.totalAmount || 0;

          yPosition -= (rowHeight + 10);
        }

        // --- VENDOR SUB-TOTAL ---
        if (yPosition < 80) {
            currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
            drawHeader(currentPage);
            yPosition = 456;
        }
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 757, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText(`Date Total:`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 493, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 566, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVat)}`, { x: 634, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorTotal)}`, { x: 700, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 20;

        grandVatable += vendorVatable;
        grandVatAmount += vendorVat;
        grandAmount += vendorTotal;
      }

      // --- GRAND TOTAL ---
      if (yPosition < 100) {
        currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
        drawHeader(currentPage);
        yPosition = 456;
      }

      yPosition -= 10;
      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`GRAND TOTAL:`, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 493, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 566, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 634, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 9, font: calibriBold });

      // --- PAGE NUMBERS ---
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${allPages.length}`, {
          x: 680, 
          y: 580,
          size: 9,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PURCHASE_REGISTER_BY_DATE_DETAILED.pdf`;
      link.click();

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF: " + error.message);
    }
    setLoading(false);
  };

  const generatePurchaseRegisterByDateSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateSummarized;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_REGISTER_BY_DATE_SUMMARIZED.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(`${invoice?.id?.toString() ?? ""}`, { x: 72, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 60;
      const lineHeight = 10;

      let grandGross = 0;
      let grandDiscounts = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition - lineHeight < bottomThreshold) {
          currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
          drawHeader(currentPage);
          yPosition = 456;
        }

        // Draw Basic Row Info
        currentPage.drawText(FormatDateToMDY(record.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record?.id ?? ""}`, { x: 105, y: yPosition, size: 8, font: calibriFont });

        const truncatedVendorName = truncateText(record?.vendorName1 ?? "", 120, calibriFont, 8);
        currentPage.drawText(truncatedVendorName, { x: 170, y: yPosition, size: 8, font: calibriFont });

        // Draw Numerics
        currentPage.drawText(`${record.terms ?? ""}`, { x: 298, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.subTotal)}`, { x: 362, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.discounts)}`, { x: 427, y: yPosition, size: 8, font: calibriFont });
        
        // Note: your data uses vaTableSales (lowercase 'a')
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 495, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 566, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 634, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 700, y: yPosition, size: 8, font: calibriFont });

        grandGross += record.subTotal || 0;
        grandDiscounts += record.discounts || 0;
        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.amount || 0;

        yPosition -= lineHeight;
      }

      // --- GRAND TOTAL ---
      if (yPosition < 100) {
        currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
        drawHeader(currentPage);
        yPosition = 456;
      }

      yPosition -= 10;
      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`GRAND TOTAL:`, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGross)}`, { x: 362, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscounts)}`, { x: 427, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 495, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 566, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 634, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 700, y: yPosition, size: 9, font: calibriBold });

      // --- PAGE NUMBERS ---
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${allPages.length}`, {
          x: 680, 
          y: 580,
          size: 9,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PURCHASE_REGISTER_BY_DATE_SUMMARIZED.pdf`;
      link.click();

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF: " + error.message);
    }
    setLoading(false);
  };

  const generatePurchaseRegisterByDocNoDetailedHandleClick = async () => {
    if (!company) {
      setFailMessage("Please fill up Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_REGISTER_BY_DOC_NO_DETAILED.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = String(text).split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(`${invoice?.id?.toString() ?? ""}`, { x: 72, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 60;
      const colWidthDesc = 85; // Adjusted based on your coordinates
      const lineHeight = 10;

      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let vendorVatable = 0;
        let vendorVat = 0;
        let vendorTotal = 0;

        for (const itemRow of record.items) {
          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          const rowHeight = Math.max(15, descLines.length * lineHeight);

          // --- PAGE BREAK CHECK ---
          if (yPosition - rowHeight < bottomThreshold) {
            currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
            drawHeader(currentPage);
            yPosition = 456;
          }

          // Draw Basic Row Info
          currentPage.drawText(`${record?.id ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatDateToMDY(record.date), { x: 100, y: yPosition, size: 8, font: calibriFont });

          currentPage.drawText(record.vendorName1, { x: 183, y: yPosition, size: 8, font: calibriFont });

          // Draw Wrapped Description
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 35,
              y: (yPosition - 10) - (i * lineHeight),
              size: 8,
              font: calibriFont,
            });
          }

          // Draw Numerics
          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 184, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 223, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 270, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)}`, { x: 340, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 385, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 453, y: yPosition - 10, size: 8, font: calibriFont });
          
          // Note: your data uses vaTableSales (lowercase 'a')
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 522, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 594, y: yPosition - 10, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 660, y: yPosition - 10, size: 8, font: calibriFont });

          vendorVatable += itemRow.vaTableSales || 0;
          vendorVat += itemRow.vat || 0;
          vendorTotal += itemRow.totalAmount || 0;

          yPosition -= (rowHeight + 10);
        }

        // --- VENDOR SUB-TOTAL ---
        if (yPosition < 80) {
            currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
            drawHeader(currentPage);
            yPosition = 456;
        }
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 757, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText(`Date Total:`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVatable)}`, { x: 522, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorVat)}`, { x: 594, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(vendorTotal)}`, { x: 660, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 20;

        grandVatable += vendorVatable;
        grandVatAmount += vendorVat;
        grandAmount += vendorTotal;
      }

      // --- GRAND TOTAL ---
      if (yPosition < 100) {
        currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
        drawHeader(currentPage);
        yPosition = 456;
      }

      yPosition -= 10;
      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`GRAND TOTAL:`, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 522, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 594, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 660, y: yPosition, size: 9, font: calibriBold });

      // --- PAGE NUMBERS ---
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${allPages.length}`, {
          x: 680, 
          y: 580,
          size: 9,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PURCHASE_REGISTER_BY_DOC_NO_DETAILED.pdf`;
      link.click();

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF: " + error.message);
    }
    setLoading(false);
  };

  const generatePurchaseRegisterByDocNoSummarizedHandleClick = async () => {
    if (!company) {
      setFailMessage("Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoSummarized;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_REGISTER_BY_DOC_NO_SUMMARIZED.pdf`;
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(`${invoice?.id?.toString() ?? ""}`, { x: 72, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 505.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 456;
      const bottomThreshold = 60;
      const lineHeight = 10;

      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition - lineHeight < bottomThreshold) {
          currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
          drawHeader(currentPage);
          yPosition = 456;
        }

        // Draw Basic Row Info
        currentPage.drawText(`${record?.id ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(FormatDateToMDY(record.date), { x: 105, y: yPosition, size: 8, font: calibriFont });

        const truncatedVendorName = truncateText(record?.vendorName1 ?? "", 120, calibriFont, 8);
        currentPage.drawText(truncatedVendorName, { x: 234, y: yPosition, size: 8, font: calibriFont });

        // Draw Numerics
        currentPage.drawText(`${record.terms ?? ""}`, { x: 423, y: yPosition, size: 8, font: calibriFont });
        
        // Note: your data uses vaTableSales (lowercase 'a')
        currentPage.drawText(`${FormatValueToDecimal(record.grossVatable)}`, { x: 494, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.vat)}`, { x: 592, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.amount)}`, { x: 682, y: yPosition, size: 8, font: calibriFont });

        grandVatable += record.grossVatable || 0;
        grandVatAmount += record.vat || 0;
        grandAmount += record.amount || 0;

        yPosition -= lineHeight;
      }

      // --- GRAND TOTAL ---
      if (yPosition < 100) {
        currentPage = pdfDoc.addPage([pages[0].getWidth(), pages[0].getHeight()]);
        drawHeader(currentPage);
        yPosition = 456;
      }

      yPosition -= 10;
      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`GRAND TOTAL:`, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 494, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 592, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 682, y: yPosition, size: 9, font: calibriBold });

      // --- PAGE NUMBERS ---
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${allPages.length}`, {
          x: 680, 
          y: 580,
          size: 9,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `PURCHASE_REGISTER_BY_DOC_NO_SUMMARIZED.pdf`;
      link.click();

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF: " + error.message);
    }
    setLoading(false);
  };

  //Excel
  const exportPurchaseRegisterByVendorDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byVendorDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Purchase Register');

      // --- 1. DEFINE COLUMNS FIRST (A to N = 14 columns) ---
      worksheet.columns = [
        { header: 'Date', key: 'date', width: 12 },            // A
        { header: 'Doc. No.', key: 'id', width: 15 },         // B
        { header: 'Salesman', key: 'salesman', width: 15 },   // C
        { header: 'Item', key: 'description', width: 35 },     // D
        { header: 'Qty', key: 'qty', width: 10 },              // E
        { header: 'UOM', key: 'uom', width: 8 },               // F
        { header: 'Unit Price', key: 'unitPrice', width: 12 }, // G
        { header: 'Disc %', key: 'discPercent', width: 10 },   // H
        { header: 'Dis. Amt.', key: 'totalDisc', width: 12 },  // I
        { header: 'Net Price', key: 'netPrice', width: 12 },   // J
        { header: 'Gross Vatable', key: 'grossVatable', width: 15 }, // K
        { header: 'Vatable', key: 'vatable', width: 15 },      // L
        { header: 'VAT', key: 'vat', width: 12 },              // M
        { header: 'Total Amount', key: 'total', width: 15 },   // N
      ];

      // --- 2. COMPANY & REPORT HEADER (Merged across A to N) ---
      // We clear Row 1 first to ensure column auto-headers don't stick there
      worksheet.getRow(1).values = []; 

      worksheet.mergeCells('A1:N1');
      const companyNameCell = worksheet.getCell('A1');
      companyNameCell.value = company.name?.toUpperCase();
      companyNameCell.font = { size: 14, bold: true };
      companyNameCell.alignment = { horizontal: 'left' };

      worksheet.mergeCells('A2:N2');
      worksheet.getCell('A2').value = company.address;
      
      worksheet.mergeCells('A3:N3');
      worksheet.getCell('A3').value = `TIN: ${company.tin}`;

      worksheet.mergeCells('A5:N5');
      const titleCell = worksheet.getCell('A5');
      titleCell.value = "PURCHASE REGISTER BY VENDOR (DETAILED)";
      titleCell.font = { size: 12, bold: true };

      worksheet.mergeCells('A6:N6');
      worksheet.getCell('A6').value = `Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`;
      
      worksheet.mergeCells('A7:N7');
      worksheet.getCell('A7').value = `Vendor: ${vendor?.vendorName1 ?? "ALL"}`;
      
      worksheet.mergeCells('A8:N8');
      worksheet.getCell('A8').value = `Date Printed: ${FormatDateToWord(new Date())}`;

      // --- 3. STYLE THE ACTUAL HEADER ROW (Row 10) ---
      const headerRow = worksheet.getRow(10);
      headerRow.values = [
        'Date', 'Doc. No.', 'Salesman', 'Item', 'Qty', 'UOM', 
        'Unit Price', 'Disc %', 'Dis. Amt.', 'Net Price', 
        'Gross Vatable', 'Vatable', 'VAT', 'Total Amount'
      ];
      
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'thin' } 
        };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFECECEC' }
        };
      });

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVat = 0;
      let grandTotal = 0;

      // --- 4. DRAW DATA ---
      _data.forEach((vendorGroup) => {
        // Vendor Name Header Row
        const vendorRow = worksheet.addRow({ date: vendorGroup.vendorName });
        vendorRow.font = { bold: true };
        vendorRow.getCell('date').fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE9E9E9' }
        };
        worksheet.mergeCells(`A${vendorRow.number}:N${vendorRow.number}`);

        let vendorGross = 0;
        let vendorVatable = 0;
        let vendorVat = 0;
        let vendorTotal = 0;

        vendorGroup.invoices.forEach((record) => {
          record.items.forEach((item) => {
            const row = worksheet.addRow({
              date: FormatDateToMDY(record.date),
              id: record.id,
              salesman: record.salesman,
              description: item.itemDescription,
              qty: item.quantity,
              uom: item.uomName,
              unitPrice: item.unitPrice,
              discPercent: (item.discountPercent || 0) / 100,
              totalDisc: item.totalDiscount,
              netPrice: item.netPrice,
              grossVatable: item.vaTableSales, // Adjust based on your logic
              vatable: item.vaTableSales,
              vat: item.vat,
              total: item.totalAmount
            });

            // Formatting columns E, G, I, J, K, L, M, N as numbers
            ['E', 'G', 'I', 'J', 'K', 'L', 'M', 'N'].forEach(col => {
              row.getCell(col).numFmt = '#,##0.00';
            });
            row.getCell('H').numFmt = '0.00%';

            vendorGross += item.vaTableSales || 0;
            vendorVatable += item.vaTableSales || 0;
            vendorVat += item.vat || 0;
            vendorTotal += item.totalAmount || 0;
          });
        });

        // --- 5. SUPPLIER SUB-TOTAL ---
        const subTotalRow = worksheet.addRow({
          description: 'Supplier Sub-Total:',
          grossVatable: vendorGross,
          vatable: vendorVatable,
          vat: vendorVat,
          total: vendorTotal
        });
        
        subTotalRow.font = { bold: true };
        // Apply styling and borders to subtotal numeric cells (K, L, M, N)
        ['K', 'L', 'M', 'N'].forEach(col => {
          const cell = subTotalRow.getCell(col);
          cell.numFmt = '#,##0.00';
          cell.border = { top: { style: 'thin' } };
        });
        
        grandGrossVatable += vendorGross;
        grandVatable += vendorVatable;
        grandVat += vendorVat;
        grandTotal += vendorTotal;
        
        worksheet.addRow([]); // Blank spacer row
      });

      // --- 6. GRAND TOTAL ---
      const grandTotalRow = worksheet.addRow({
        description: 'GRAND TOTAL:',
        grossVatable: grandGrossVatable,
        vatable: grandVatable,
        vat: grandVat,
        total: grandTotal
      });
      
      grandTotalRow.font = { bold: true, size: 11 };
      ['K', 'L', 'M', 'N'].forEach(col => {
        const cell = grandTotalRow.getCell(col);
        cell.numFmt = '#,##0.00';
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFF00' } // Yellow
        };
        cell.border = { 
            top: { style: 'double' }, 
            bottom: { style: 'double' } 
        };
      });

      // --- 7. EXPORT ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Purchase_Register_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel: " + error.message);
    }
    setLoading(false);
  };

  const exportPurchaseRegisterByDateDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Purchase Register');

      // --- 1. DEFINE COLUMNS (A to M = 13 columns) ---
      worksheet.columns = [
        { header: 'Date', key: 'date', width: 12 },            // A
        { header: 'Doc. No.', key: 'id', width: 15 },         // B
        { header: 'Vendor', key: 'vendor', width: 25 },       // C
        { header: 'Item', key: 'description', width: 35 }, // D
        { header: 'Qty', key: 'qty', width: 10 },              // E
        { header: 'UOM', key: 'uom', width: 8 },               // F
        { header: 'Gross Price', key: 'unitPrice', width: 12 }, // G
        { header: 'Discount.', key: 'totalDisc', width: 12 }, // H
        { header: 'Net Price', key: 'netPrice', width: 12 },   // I
        { header: 'Gross Vatable', key: 'grossVatable', width: 15 }, // J
        { header: 'Vatable', key: 'vatable', width: 15 },      // K
        { header: 'VAT', key: 'vat', width: 12 },              // L
        { header: 'Total Amount', key: 'total', width: 15 },   // M
      ];

      // --- 2. HEADER SECTION ---
      worksheet.getRow(1).values = []; // Clear auto-headers from Row 1

      worksheet.mergeCells('A1:M1');
      worksheet.getCell('A1').value = company.name?.toUpperCase();
      worksheet.getCell('A1').font = { size: 14, bold: true };

      worksheet.mergeCells('A2:M2');
      worksheet.getCell('A2').value = company.address;

      worksheet.mergeCells('A3:M3');
      worksheet.getCell('A3').value = `TIN: ${company.tin}`;

      worksheet.mergeCells('A5:M5');
      worksheet.getCell('A5').value = "PURCHASE REGISTER BY DATE (DETAILED)";
      worksheet.getCell('A5').font = { size: 12, bold: true };

      worksheet.mergeCells('A6:M6');
      worksheet.getCell('A6').value = `Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`;
      
      worksheet.mergeCells('A7:M7');
      worksheet.getCell('A7').value = `Reference: ${invoice?.id ?? "ALL"}`;

      worksheet.mergeCells('A8:M8');
      worksheet.getCell('A8').value = `Date Printed: ${FormatDateToWord(new Date())}`;

      // Style Table Header (Row 10)
      const headerRow = worksheet.getRow(10);
      headerRow.values = worksheet.columns.map(c => c.header);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
        cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
      });

      let grandVatable = 0;
      let grandVat = 0;
      let grandTotal = 0;

      // --- 3. DATA ROWS ---
      _data.forEach((record) => {
        let dateVatable = 0;
        let dateVat = 0;
        let dateTotal = 0;

        record.items.forEach((item, index) => {
          const row = worksheet.addRow({
            // Only show Date, Doc No, and Vendor on the first item of the group
            date: index === 0 ? FormatDateToMDY(record.date) : '',
            id: index === 0 ? record.id : '',
            vendor: index === 0 ? record.vendorName1 : '',
            description: item.itemDescription,
            qty: item.quantity,
            uom: item.uomName,
            unitPrice: item.unitPrice,
            totalDisc: item.totalDiscount,
            netPrice: item.netPrice,
            grossVatable: item.vaTableSales,
            vatable: item.vaTableSales,
            vat: item.vat,
            total: item.totalAmount
          });

          // Numeric Formatting
          ['E', 'G', 'H', 'I', 'J', 'K', 'L', 'M'].forEach(col => {
            row.getCell(col).numFmt = '#,##0.00';
          });

          dateVatable += item.vaTableSales || 0;
          dateVat += item.vat || 0;
          dateTotal += item.totalAmount || 0;
        });

        // --- 4. DATE SUB-TOTAL ---
        const subTotalRow = worksheet.addRow({
          description: 'Date Total:',
          grossVatable: dateVatable,
          vatable: dateVatable,
          vat: dateVat,
          total: dateTotal
        });
        
        subTotalRow.font = { bold: true };
        ['J', 'K', 'L', 'M'].forEach(col => {
          subTotalRow.getCell(col).numFmt = '#,##0.00';
          subTotalRow.getCell(col).border = { top: { style: 'thin' } };
        });

        grandVatable += dateVatable;
        grandVat += dateVat;
        grandTotal += dateTotal;

        worksheet.addRow([]); // Gap between dates
      });

      // --- 5. GRAND TOTAL ---
      const grandTotalRow = worksheet.addRow({
        description: 'GRAND TOTAL:',
        grossVatable: grandVatable,
        vatable: grandVatable,
        vat: grandVat,
        total: grandTotal
      });

      grandTotalRow.font = { bold: true, size: 11 };
      ['J', 'K', 'L', 'M'].forEach(col => {
        const cell = grandTotalRow.getCell(col);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } };
        cell.border = { top: { style: 'double' }, bottom: { style: 'double' } };
      });

      // --- 6. EXPORT ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Purchase_Register_By_Date_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel: " + error.message);
    }
    setLoading(false);
  };

  const exportPurchaseRegisterByDateSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateSummarized;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Summarized Purchase Register');

      // --- 1. DEFINE COLUMNS (A to J = 10 columns) ---
      worksheet.columns = [
        { header: 'Date', key: 'date', width: 12 },             // A
        { header: 'Doc. No.', key: 'id', width: 15 },          // B
        { header: 'Vendor', key: 'vendor', width: 30 },    // C
        { header: 'Terms', key: 'terms', width: 10 },           // D
        { header: 'Gross', key: 'subTotal', width: 15 },        // E
        { header: 'Discount', key: 'discounts', width: 12 },   // F
        { header: 'Gross Vatable', key: 'grossVatable', width: 15 }, // G
        { header: 'Vatable', key: 'vatable', width: 15 },       // H
        { header: 'VAT', key: 'vat', width: 12 },               // I
        { header: 'Amount', key: 'total', width: 15 },    // J
      ];

      // --- 2. HEADER SECTION ---
      worksheet.getRow(1).values = []; // Clear auto-inserted headers from Row 1

      worksheet.mergeCells('A1:J1');
      worksheet.getCell('A1').value = company.name?.toUpperCase();
      worksheet.getCell('A1').font = { size: 14, bold: true };

      worksheet.mergeCells('A2:J2');
      worksheet.getCell('A2').value = company.address;

      worksheet.mergeCells('A3:J3');
      worksheet.getCell('A3').value = `TIN: ${company.tin}`;

      worksheet.mergeCells('A5:J5');
      worksheet.getCell('A5').value = "PURCHASE REGISTER BY DATE (SUMMARIZED)";
      worksheet.getCell('A5').font = { size: 12, bold: true };

      worksheet.mergeCells('A6:J6');
      worksheet.getCell('A6').value = `Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`;
      
      worksheet.mergeCells('A7:J7');
      worksheet.getCell('A7').value = `Reference: ${invoice?.id ?? "ALL"}`;

      worksheet.mergeCells('A8:J8');
      worksheet.getCell('A8').value = `Date Printed: ${FormatDateToWord(new Date())}`;

      // Style Table Header (Row 10)
      const headerRow = worksheet.getRow(10);
      headerRow.values = worksheet.columns.map(c => c.header);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
        cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
      });

      let grandGross = 0;
      let grandDiscounts = 0;
      let grandVatable = 0;
      let grandVat = 0;
      let grandTotal = 0;

      // --- 3. DATA ROWS ---
      _data.forEach((record) => {
        const row = worksheet.addRow({
          date: FormatDateToMDY(record.date),
          id: record.id,
          vendor: record.vendorName1,
          terms: record.terms,
          subTotal: record.subTotal,
          discounts: record.discounts,
          grossVatable: record.grossVatable,
          vatable: record.grossVatable,
          vat: record.vat,
          total: record.amount
        });

        // Numeric Formatting for columns E to J
        ['E', 'F', 'G', 'H', 'I', 'J'].forEach(col => {
          row.getCell(col).numFmt = '#,##0.00';
        });

        grandGross += record.subTotal || 0;
        grandDiscounts += record.discounts || 0;
        grandVatable += record.grossVatable || 0;
        grandVat += record.vat || 0;
        grandTotal += record.amount || 0;
      });

      // --- 4. GRAND TOTAL ---
      const grandTotalRow = worksheet.addRow({
        vendor: 'GRAND TOTAL:',
        subTotal: grandGross,
        discounts: grandDiscounts,
        grossVatable: grandVatable,
        vatable: grandVatable,
        vat: grandVat,
        total: grandTotal
      });

      grandTotalRow.font = { bold: true, size: 11 };
      
      // Formatting and Styling for Grand Total
      ['E', 'F', 'G', 'H', 'I', 'J'].forEach(col => {
        const cell = grandTotalRow.getCell(col);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } }; // Yellow
        cell.border = { top: { style: 'double' }, bottom: { style: 'double' } };
      });

      // --- 5. EXPORT ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Purchase_Register_By_Date_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel: " + error.message);
    }
    setLoading(false);
  };

  const exportPurchaseRegisterByDocNoDetailedExcel = async () => {
    if (!company) {
      setFailMessage("Please fill up Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Purchase Register');

      // --- 1. DEFINE COLUMNS (A to M = 13 columns) ---
      worksheet.columns = [
        { header: 'Doc. No.', key: 'id', width: 15 },          // A
        { header: 'Date', key: 'date', width: 12 },             // B
        { header: 'Vendor Name', key: 'vendor', width: 25 },    // C
        { header: 'Item Description', key: 'description', width: 35 }, // D
        { header: 'Qty', key: 'qty', width: 10 },               // E
        { header: 'UOM', key: 'uom', width: 8 },                // F
        { header: 'Unit Price', key: 'unitPrice', width: 12 },  // G
        { header: 'Disc %', key: 'discPercent', width: 10 },    // H
        { header: 'Disc. Amt.', key: 'discAmt', width: 12 },    // I
        { header: 'Net Price', key: 'netPrice', width: 12 },    // J
        { header: 'Vatable Sales', key: 'vatable', width: 15 }, // K
        { header: 'VAT', key: 'vat', width: 12 },               // L
        { header: 'Total Amount', key: 'total', width: 15 },    // M
      ];

      // --- 2. HEADER SECTION ---
      worksheet.getRow(1).values = []; // Clear auto-headers

      worksheet.mergeCells('A1:M1');
      worksheet.getCell('A1').value = company.name?.toUpperCase();
      worksheet.getCell('A1').font = { size: 14, bold: true };

      worksheet.mergeCells('A2:M2');
      worksheet.getCell('A2').value = company.address;

      worksheet.mergeCells('A3:M3');
      worksheet.getCell('A3').value = `TIN: ${company.tin}`;

      worksheet.mergeCells('A5:M5');
      worksheet.getCell('A5').value = "PURCHASE REGISTER BY DOC NO. (DETAILED)";
      worksheet.getCell('A5').font = { size: 12, bold: true };

      worksheet.mergeCells('A6:M6');
      worksheet.getCell('A6').value = `Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`;

      worksheet.mergeCells('A7:M7');
      worksheet.getCell('A7').value = `Date Printed: ${FormatDateToWord(new Date())}`;

      // Style Table Header Row (Row 10)
      const headerRow = worksheet.getRow(10);
      headerRow.values = worksheet.columns.map(c => c.header);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
      });

      let grandVatable = 0;
      let grandVat = 0;
      let grandTotal = 0;

      // --- 3. DATA ROWS ---
      _data.forEach((record) => {
        let docVatable = 0;
        let docVat = 0;
        let docTotal = 0;

        record.items.forEach((item, index) => {
          const row = worksheet.addRow({
            // Only show Doc No, Date, and Vendor on the first item of the document group
            id: index === 0 ? record.id : '',
            date: index === 0 ? FormatDateToMDY(record.date) : '',
            vendor: index === 0 ? record.vendorName1 : '',
            description: item.itemDescription,
            qty: item.quantity,
            uom: item.uomName,
            unitPrice: item.unitPrice,
            discPercent: (item.discountPercent || 0) / 100, // Format as fraction for % formatting
            discAmt: item.totalDiscount,
            netPrice: item.netPrice,
            vatable: item.vaTableSales,
            vat: item.vat,
            total: item.totalAmount
          });

          // Formatting numbers
          ['E', 'G', 'I', 'J', 'K', 'L', 'M'].forEach(col => {
            row.getCell(col).numFmt = '#,##0.00';
          });
          row.getCell('H').numFmt = '0.00%'; // Format Disc %

          docVatable += item.vaTableSales || 0;
          docVat += item.vat || 0;
          docTotal += item.totalAmount || 0;
        });

        // --- 4. DOCUMENT SUB-TOTAL ---
        const subTotalRow = worksheet.addRow({
          description: `Total for ${record.id}:`,
          vatable: docVatable,
          vat: docVat,
          total: docTotal
        });

        subTotalRow.font = { bold: true };
        ['K', 'L', 'M'].forEach(col => {
          subTotalRow.getCell(col).numFmt = '#,##0.00';
          subTotalRow.getCell(col).border = { top: { style: 'thin' } };
        });

        grandVatable += docVatable;
        grandVat += docVat;
        grandTotal += docTotal;

        worksheet.addRow([]); // Blank spacer between documents
      });

      // --- 5. GRAND TOTAL ---
      const grandTotalRow = worksheet.addRow({
        description: 'GRAND TOTAL:',
        vatable: grandVatable,
        vat: grandVat,
        total: grandTotal
      });

      grandTotalRow.font = { bold: true, size: 11 };
      ['K', 'L', 'M'].forEach(col => {
        const cell = grandTotalRow.getCell(col);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } }; // Yellow
        cell.border = { top: { style: 'double' }, bottom: { style: 'double' } };
      });

      // --- 6. EXPORT ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Purchase_Register_DocNo_Detailed_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel: " + error.message);
    }
    setLoading(false);
  };

  const exportPurchaseRegisterByDocNoSummarizedExcel = async () => {
    if (!company) {
      setFailMessage("Please fill up Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDocNoSummarized;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Summarized Purchase Register');

      // --- 1. DEFINE COLUMNS (A to G = 7 columns) ---
      worksheet.columns = [
        { header: 'Doc. No.', key: 'id', width: 18 },          // A
        { header: 'Date', key: 'date', width: 15 },             // B
        { header: 'Vendor Name', key: 'vendor', width: 35 },    // C
        { header: 'Terms', key: 'terms', width: 12 },           // D
        { header: 'Vatable Sales', key: 'vatable', width: 18 }, // E
        { header: 'VAT', key: 'vat', width: 15 },               // F
        { header: 'Total Amount', key: 'total', width: 18 },    // G
      ];

      // --- 2. HEADER SECTION ---
      worksheet.getRow(1).values = []; // Clear auto-headers from Row 1

      worksheet.mergeCells('A1:G1');
      worksheet.getCell('A1').value = company.name?.toUpperCase();
      worksheet.getCell('A1').font = { size: 14, bold: true };

      worksheet.mergeCells('A2:G2');
      worksheet.getCell('A2').value = company.address;

      worksheet.mergeCells('A3:G3');
      worksheet.getCell('A3').value = `TIN: ${company.tin}`;

      worksheet.mergeCells('A5:G5');
      worksheet.getCell('A5').value = "PURCHASE REGISTER BY DOC NO. (SUMMARIZED)";
      worksheet.getCell('A5').font = { size: 12, bold: true };

      worksheet.mergeCells('A6:G6');
      worksheet.getCell('A6').value = `Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`;

      worksheet.mergeCells('A7:G7');
      worksheet.getCell('A7').value = `Date Printed: ${FormatDateToWord(new Date())}`;

      // Style Table Header (Row 10)
      const headerRow = worksheet.getRow(10);
      headerRow.values = worksheet.columns.map(c => c.header);
      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center' };
        cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE0E0E0' } };
      });

      let grandVatable = 0;
      let grandVat = 0;
      let grandTotal = 0;

      // --- 3. DATA ROWS ---
      _data.forEach((record) => {
        const row = worksheet.addRow({
          id: record.id,
          date: FormatDateToMDY(record.date),
          vendor: record.vendorName1,
          terms: record.terms,
          vatable: record.grossVatable,
          vat: record.vat,
          total: record.amount
        });

        // Numeric Formatting for columns E, F, G
        ['E', 'F', 'G'].forEach(col => {
          row.getCell(col).numFmt = '#,##0.00';
        });

        grandVatable += record.grossVatable || 0;
        grandVat += record.vat || 0;
        grandTotal += record.amount || 0;
      });

      // --- 4. GRAND TOTAL ---
      const grandTotalRow = worksheet.addRow({
        vendor: 'GRAND TOTAL:',
        vatable: grandVatable,
        vat: grandVat,
        total: grandTotal
      });

      grandTotalRow.font = { bold: true, size: 11 };
      
      // Formatting and Styling for Grand Total
      ['E', 'F', 'G'].forEach(col => {
        const cell = grandTotalRow.getCell(col);
        cell.numFmt = '#,##0.00';
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFF00' } }; // Yellow
        cell.border = { top: { style: 'double' }, bottom: { style: 'double' } };
      });

      // --- 5. EXPORT ---
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `Purchase_Register_ByDocNo_Summarized_${new Date().getTime()}.xlsx`);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel: " + error.message);
    }
    setLoading(false);
  };

//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasSalesRegister) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Purchase Register`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Purchase Invoices.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Vendor 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Vendor"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                readOnly
              />
              {!vendor ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Item"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${item ? `${item?.itemCode} - ${item?.itemDescription}` : ""}`}
                readOnly
              />
              {!item ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelect}>
                  <SearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setItem(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Terms
            </label>
            <TermsSelect data={terms} setData={setTerms} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Document No.
            </label>
            <PurchaseInvoiceOptionalVendorSelect data={invoice} setData={setInvoice} isEditable={true} vendorId={vendor ? vendor?.vendorId : "All"}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Purchase Registers</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "By Vendor", 
                pdf_detailed: generatePurchaseRegisterByVendorDetailedHandleClick, 
                excel_detailed: exportPurchaseRegisterByVendorDetailedExcel, // Replace with your Excel function
              },
              { 
                label: "By Date", 
                pdf_detailed: generatePurchaseRegisterByDateDetailedHandleClick, 
                pdf_summarized: generatePurchaseRegisterByDateSummarizedHandleClick,
                excel_detailed: exportPurchaseRegisterByDateDetailedExcel, 
                excel_summarized: exportPurchaseRegisterByDateSummarizedExcel 
              },
              { 
                label: "By Doc No", 
                pdf_detailed: generatePurchaseRegisterByDocNoDetailedHandleClick, 
                pdf_summarized: generatePurchaseRegisterByDocNoSummarizedHandleClick,
                excel_detailed: exportPurchaseRegisterByDocNoDetailedExcel, 
                excel_summarized: exportPurchaseRegisterByDocNoSummarizedExcel
              }
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  { group.pdf_detailed &&
                    <button 
                      onClick={group.pdf_detailed} 
                      className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                      title="Download PDF Detailed"
                    >
                      <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                    </button>
                  }
                  
                  { group.pdf_summarized &&
                    <button 
                      onClick={group.pdf_summarized} 
                      className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                    >
                      Summarized
                    </button>
                  }

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  { group.excel_detailed &&
                    <button 
                      onClick={group.excel_detailed} 
                      className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                    >
                      Excel Detailed
                    </button>
                  }
                  
                  { group.excel_summarized &&
                    <button 
                      onClick={group.excel_summarized} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ.
                    </button>
                  }
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
      
      <VendorSelect 
        visible={showVendorSelect} 
        onClose={closeVendorSelect}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
      
      <ItemSelect 
        visible={showItemSelect} 
        onClose={closeItemSelect}
        modalName={"Select Item"}
        data={item} setData={setItem}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}